module.exports = __webpack_public_path__ + "static/media/1.24a511f9.jpg";